export default {
   
    cptCodeValue:null,
    financialValue:null,
    referalCount:null,
    referalCountRecord:null,
    callStatus:null
}